import UIkit from 'uikit';

const initAutotyping = () => {
    const content = document.querySelector('.typing-content');
    const source = document.querySelector('.typing-content .typing-text-source');
    const container = document.querySelector('.typing-target');
  
    if (!source || !container) return;
  
    const target = document.createElement(source.tagName.toLowerCase());
    target.className = source.className;
    container.appendChild(target);
  
    function fadeInWordsWithHTML(htmlString, container) {
      container.innerHTML = '';
  
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;
  
      function wrapNodes(node) {
        const fragments = [];
  
        node.childNodes.forEach(child => {
          if (child.nodeType === Node.TEXT_NODE) {
            const words = child.textContent.split(/(\s+)/);
  
            words.forEach(word => {
              if (word.trim() === '') {
                fragments.push(document.createTextNode(word));
              } else {
                const span = document.createElement('span');
                span.textContent = word;
                span.style.opacity = 0;
                span.style.transition = 'opacity 0.5s ease';
                fragments.push(span);
              }
            });
          } else if (child.nodeType === Node.ELEMENT_NODE) {
            const wrapper = document.createElement('span');
            wrapper.style.opacity = 0;
            wrapper.style.transition = 'opacity 0.5s ease';
  
            wrapper.appendChild(child.cloneNode(true));
            fragments.push(wrapper);
          }
        });
  
        return fragments;
      }
  
      const wrappedNodes = wrapNodes(tempDiv);

      if(wrappedNodes.length > 0) {
        wrappedNodes.forEach(node => container.appendChild(node));
    
        wrappedNodes
        .filter(node => node && node.style)
        .forEach((node, i) => {
            setTimeout(() => {
            node.style.opacity = 1;
            }, 60 * i);
        });
      }
    }
  
    const originalDisplay = source.style.display;
    content.style.display = 'block';
    source.style.display = 'block';
  
    const height = source.offsetHeight;
  
    source.style.display = originalDisplay || 'none';
    content.style.display = originalDisplay || 'none';
    container.style.minHeight = height + 'px';
  
    UIkit.util.on('.autotyping-section', 'inview', () => {
      if (target.textContent.trim() === '') {
        fadeInWordsWithHTML(source.innerHTML.trim(), target);
      }
    });
}

export default initAutotyping